import * as React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import { hot } from 'react-hot-loader'
import './styles.scss'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { PhotoSlide } from 'components/photoslide'
import { Footer } from 'components/footer'
import ReactFullpage from '@fullpage/react-fullpage'

const ARTICLE_ID = '18446938'

const img0 = require('./img/00.jpg')
const img0mobile = require('./img/00-mobile.jpg')
const img1 = require('./img/01.jpg')
const img1mobile = require('./img/01-mobile.jpg')
const img2 = require('./img/02.jpg')
const img2mobile = require('./img/02-mobile.jpg')
const img3 = require('./img/03.jpg')
const img3mobile = require('./img/03-mobile.jpg')
const img4 = require('./img/04.jpg')
const img4mobile = require('./img/04-mobile.jpg')
const img5 = require('./img/05.jpg')
const img5mobile = require('./img/05-mobile.jpg')
const img6 = require('./img/06.jpg')
const img6mobile = require('./img/06-mobile.jpg')
const img7 = require('./img/07.jpg')
const img7mobile = require('./img/07-mobile.jpg')
const img8 = require('./img/08.jpg')
const img8mobile = require('./img/08-mobile.jpg')
const img9 = require('./img/09.jpg')
const img9mobile = require('./img/09-mobile.jpg')

class AppComponent extends React.Component {
  constructor() {
    super()
    this.state = {
      isMobile: window.innerWidth < 800,
      slideTransition: 'slide', // slide|fade
      activeSlide: 0,
      captionOpen: false,
      captionWasOpen: false,
      publicationDate: 1542779100,
    }
    this.onLeave = this.onLeave.bind(this)
    this.afterLoad = this.afterLoad.bind(this)
    this.toggleCaption = this.toggleCaption.bind(this)
    this.updateDimensions = this.updateDimensions.bind(this)
  }
  updateDimensions() {
    // console.log('updateDimensions')
    this.setState({ isMobile: window.innerWidth < 800 })
  }

  onLeave(index, nextIndex, direction) {
    // console.log('onLeave')
    this.setState({ captionWasOpen: this.state.captionOpen })
    this.setState({ isSliding: true })
    this.setState({ captionOpen: false })

    // console.log('nextIndex: ', nextIndex.index)
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'Interactions',
      event_action: 'scroll',
      event_label: `scrolled to: ${nextIndex.index}`,
    })
  }
  afterLoad(anchorLink, index, slideAnchor, slideIndex) {
    // console.log('afterLoad')
    this.setState({ isSliding: false })
    // console.log('active index: ', index.index)
    this.setState({ activeSlide: index.index })
    if (!this.state.isMobile) {
      this.toggleCaption()
    }
  }
  componentDidMount() {
    window.addEventListener('resize', this.updateDimensions)
  }

  toggleCaption() {
    // console.log('toggleCaption')
    this.setState({ captionOpen: !this.state.captionOpen })
    if (this.state.isMobile && !this.state.captionOpen) {
      // console.log('click toggle -> TRACK: ', this.state.activeSlide)
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: 'Interactions',
        event_action: 'click',
        event_label: `show caption: ${this.state.activeSlide}`,
      })
    }
  }

  render() {
    return (
      <div className={'index ' + this.state.slideTransition}>
        <Masthead articleId={ARTICLE_ID} inverted />
        <ReactFullpage
          onLeave={this.onLeave}
          afterLoad={this.afterLoad}
          navigation
          navigationPosition={'right'}
          navigationTooltips={['', '', '']}
          licenseKey='9B91FA5D-FFD748B8-88A4F827-CEF667F2'
          render={({ state, fullpageApi }) => {
            return (
              <ReactFullpage.Wrapper>
                <div
                  className='section'
                  id='section-0'
                  style={{
                    backgroundImage: `url(${
                      this.state.isMobile ? img0mobile : img0
                    })`,
                  }}
                >
                  <h1>100-jährige Kriegsnarben</h1>
                  <p className='lead'>
                    Vor 100 Jahren endete der Erste Weltkrieg. Die Schatten der
                    einst blutigen Spuren sind noch heute sichtbar, wie diese
                    Bilder zeigen.
                  </p>
                  <div className='scroll-hint'>
                    <p style={{ textAlign: 'center' }}>
                      Bitte scrollen
                      <br />
                      <i className='icon angle down huge' />
                    </p>
                  </div>
                </div>
                <PhotoSlide
                  id='section-01'
                  isMobile={this.state.isMobile}
                  imgMobile={img1mobile}
                  imgDesktop={img1}
                  isSliding={this.state.isSliding}
                  captionOpen={this.state.captionOpen}
                  captionWasOpen={this.state.captionWasOpen}
                  toggleCaption={this.toggleCaption}
                  caption='Bombenkrater und Schützengräben von einst: Aufnahme einer Drohne des Schlachtfelds in Beaumont-Hamel, Frankreich.'
                  credits='Foto: Keystone'
                />
                <PhotoSlide
                  id='section-02'
                  isMobile={this.state.isMobile}
                  imgMobile={img5mobile}
                  imgDesktop={img5}
                  isSliding={this.state.isSliding}
                  captionOpen={this.state.captionOpen}
                  captionWasOpen={this.state.captionWasOpen}
                  toggleCaption={this.toggleCaption}
                  caption='Luftaufnahme einer Drohne des damaligen Schlachtfelds in Beaumont-Hamel.'
                  credits='Foto: Keystone'
                />
                <PhotoSlide
                  id='section-03'
                  isMobile={this.state.isMobile}
                  imgMobile={img2mobile}
                  imgDesktop={img2}
                  isSliding={this.state.isSliding}
                  captionOpen={this.state.captionOpen}
                  captionWasOpen={this.state.captionWasOpen}
                  toggleCaption={this.toggleCaption}
                  caption='Mit über einer Million getöteten, verwundeten und vermissten Soldaten war die 141 Tage dauernde Schlacht an der Somme die verlustreichste Schlacht an der Westfront. Die Schützengräben in Beaumont-Hamel sind heute noch zu erkennen.'
                  credits='Foto: 9. November 2018, Christopher Furlong/Getty Images'
                />
                <PhotoSlide
                  id='section-04'
                  isMobile={this.state.isMobile}
                  imgMobile={img3mobile}
                  imgDesktop={img3}
                  isSliding={this.state.isSliding}
                  captionOpen={this.state.captionOpen}
                  captionWasOpen={this.state.captionWasOpen}
                  toggleCaption={this.toggleCaption}
                  caption='Aussenansicht eines Bunkers im Wald von Spincourt. Tausende der abgefeuerten Granaten, die während der Schlacht nicht explodierten, sind immer noch in der Region verstreut.'
                  credits='Foto: 2016, Sean Gallup/Getty Images'
                />
                <PhotoSlide
                  id='section-05'
                  isMobile={this.state.isMobile}
                  imgMobile={img4mobile}
                  imgDesktop={img4}
                  isSliding={this.state.isSliding}
                  captionOpen={this.state.captionOpen}
                  captionWasOpen={this.state.captionWasOpen}
                  toggleCaption={this.toggleCaption}
                  caption='Ein ehemaliger Bunker der deutschen Armee im Wald von Spincourt in der Nähe von Verdun. Ein halbes Dutzend dieser Bunker steht heute noch in dieser Gegend.'
                  credits='Foto: 2014, Sean Gallup/Getty Images'
                />
                <PhotoSlide
                  id='section-06'
                  isMobile={this.state.isMobile}
                  imgMobile={img6mobile}
                  imgDesktop={img6}
                  isSliding={this.state.isSliding}
                  captionOpen={this.state.captionOpen}
                  captionWasOpen={this.state.captionWasOpen}
                  toggleCaption={this.toggleCaption}
                  caption='Ein mächtiger Baum hat sich über die Jahre zwei Steinkreuze auf dem deutschen Militärfriedhof im belgischen Hooglede einverleibt.'
                  credits='Foto: 2014, Christopher Furlong/Getty Images'
                />
                <PhotoSlide
                  id='section-07'
                  isMobile={this.state.isMobile}
                  imgMobile={img7mobile}
                  imgDesktop={img7}
                  isSliding={this.state.isSliding}
                  captionOpen={this.state.captionOpen}
                  captionWasOpen={this.state.captionWasOpen}
                  toggleCaption={this.toggleCaption}
                  caption='Nach der Rückeroberung von Fort Douaumont und Fort Vaux durch französische Truppen 1916, diente dieser Graben als Verbindung zwischen Belleville, Fort Douaumont und dem zerstörten Douaumont, um Truppen zu versorgen und um Verletzte zu evakuieren.'
                  credits='Foto: 30. März 2014, Charles Platiau/Reuters'
                />
                <PhotoSlide
                  id='section-08'
                  isMobile={this.state.isMobile}
                  imgMobile={img8mobile}
                  imgDesktop={img8}
                  isSliding={this.state.isSliding}
                  captionOpen={this.state.captionOpen}
                  captionWasOpen={this.state.captionWasOpen}
                  toggleCaption={this.toggleCaption}
                  caption='Die unter Denkmalschutz stehende Ruine des Schlosses Soupir, das im 16. Jahrhundert entstand und im Ersten Weltkrieg zerstört wurde. Sie steht in der Nähe des Höhenzugs Chemin des Dames. Hier fand auf wenigen Quadratkilometern eine der blutigsten Materialschlachten des gesamten Kriegs statt.'
                  credits='Foto: 25. März 2017, Francois Nascimbeni/ AFP'
                />
                <PhotoSlide
                  id='section-09'
                  isMobile={this.state.isMobile}
                  imgMobile={img9mobile}
                  imgDesktop={img9}
                  isSliding={this.state.isSliding}
                  captionOpen={this.state.captionOpen}
                  captionWasOpen={this.state.captionWasOpen}
                  toggleCaption={this.toggleCaption}
                  caption='Überreste eines Stacheldrahtzauns in der Nähe von Verdun, wo sich deutsche und französische Truppen während zehn Monaten eine der erbittertsten Schlachten des Ersten Weltkriegs lieferten.'
                  credits='Foto: 27. August 2014, Sean Gallup/Getty Images'
                />
                <div className='section' id='section-10' style={{ padding: 0 }}>
                  <Footer
                    articleId={ARTICLE_ID}
                    publicationDate={this.state.publicationDate}
                  />
                </div>
              </ReactFullpage.Wrapper>
            )
          }}
        />
      </div>
    )
  }
}

export default hot(module)(AppComponent)
